<template>
    <section class="app__container">
 <section class="panel__container">
    <div class="panel__buttons">
        <button class="panel__button generateHTML" @click="handlePopUpHTML">Generate HTML</button>
        <!--<router-link to="/" class="panel__button navLink">Home</router-link>-->
        <button @click="$router.go(-1)" class="panel__button navLink">Home</button>
    </div>
    <section class="panel__wrapper">
            <PopUpInput />
        </section>
    </section>

 <section class="generatedHTML__container">
    <GeneratePopUpHTML />
  </section>
  <PopUpTemplate />
  </section>

</template>

<script setup>
import PopUpInput from '@/components/PopUp/PopUpInput.vue'
import PopUpTemplate from '@/components/PopUp/PopUpTemplate.vue'
import GeneratePopUpHTML from '@/components/PopUp/GeneratePopUpHTML.vue'
import {generatePopUpHTML} from '@/helper/helper'

const handlePopUpHTML = () => {
    generatePopUpHTML()
}
</script>

<style>

</style>